import React, { useState } from 'react';
import './styles.css';

var Index = function Index(_ref) {
  var initials = _ref.initials,
      avatar = _ref.avatar,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 150 : _ref$size,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 52 : _ref$fontSize;

  var _useState = useState(!avatar),
      showInitials = _useState[0],
      setShowInitials = _useState[1];

  var fallbackToInitials = function fallbackToInitials() {
    setShowInitials(true);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "profile-avatar__container " + (showInitials && 'profile-avatar__container__initial-background'),
    style: {
      width: size,
      height: size
    }
  }, showInitials ? /*#__PURE__*/React.createElement("span", {
    className: "profile-avatar__initials",
    style: {
      fontSize: fontSize
    }
  }, initials) : /*#__PURE__*/React.createElement("img", {
    className: "profile-avatar__pic",
    src: avatar,
    onError: fallbackToInitials
  }));
};

export default Index;